module.exports = __webpack_public_path__ + "img/twogirls.b307a991.png";